import { IconComponentConfig } from '../icon/icon-component-config.interface';
import { TimelineItemColor } from './timeline-item-color.enum';

export interface TimelineItem {
  title?: string;
  subtitle?: string;
  paragraph?: string;
  icon?: IconComponentConfig;
  date?: Date;
  color: TimelineItemColor;
}
